import { getMemberTypesForDepartment } from "./orgHelpers";

export const DEFAULT_ORG_STRUCTURE_ID = "departments-branches";

export const ORG_STRUCTURES = [
  {
    id: "departments-branches",
    name: "إدارات وفروع تشغيل",
    summary: "إدارات في المقر، وفروع ميدانية تحت إدارة التشغيل.",
    fit: "مناسب للشركات التي تجمع بين مقر إداري وفروع.",
    levels: [
      "المدير العام",
      "مدير الإدارة",
      "مدير المنطقة",
      "مدير الفرع",
      "مشرف",
      "موظف",
    ],
    ranks: [
      "employee",
      "supervisor",
      "section-manager",
      "branch-manager",
      "regional-manager",
      "department-manager",
    ],
    usesBranches: true,
    usesSections: true,
  },
  {
    id: "departments-sections",
    name: "إدارات وأقسام",
    summary: "كل إدارة تنقسم إلى أقسام داخل المقر، بدون فروع ميدانية.",
    fit: "مناسب للشركات المركزية.",
    levels: ["المدير العام", "مدير الإدارة", "مدير القسم", "موظف"],
    ranks: ["employee", "section-manager", "department-manager"],
    usesBranches: false,
    usesSections: true,
  },
  {
    id: "regions-branches",
    name: "مناطق وفروع",
    summary: "مناطق تجمع عدة فروع، وكل فرع له مدير ومشرفون.",
    fit: "مناسب لسلاسل الفروع.",
    levels: [
      "المدير العام",
      "مدير الإدارة",
      "مدير المنطقة",
      "مدير الفرع",
      "مشرف",
      "موظف",
    ],
    ranks: [
      "employee",
      "supervisor",
      "branch-manager",
      "regional-manager",
      "department-manager",
    ],
    usesBranches: true,
    usesSections: false,
  },
  {
    id: "functional",
    name: "هيكل وظيفي",
    summary: "تجميع حسب التخصص: إدارة، ثم قسم، ثم مشرف فريق.",
    fit: "مناسب عندما يتبع الموظف مدير وظيفته داخل المقر.",
    levels: ["المدير العام", "مدير الإدارة", "مدير القسم", "مشرف", "موظف"],
    ranks: ["employee", "supervisor", "section-manager", "department-manager"],
    usesBranches: false,
    usesSections: true,
  },
  {
    id: "simple",
    name: "هيكل هرمي بسيط",
    summary: "مدير عام، ثم مديرو الإدارات، ثم الموظفون مباشرة.",
    fit: "مناسب للفرق الصغيرة.",
    levels: ["المدير العام", "مدير الإدارة", "موظف"],
    ranks: ["employee", "department-manager"],
    usesBranches: false,
    usesSections: false,
  },
];

export function getOrgStructureById(id) {
  return (
    ORG_STRUCTURES.find((structure) => structure.id === id) || ORG_STRUCTURES[0]
  );
}

export function normalizeOrgStructures(remote) {
  if (!Array.isArray(remote) || remote.length === 0) return ORG_STRUCTURES;
  return remote.map((item) => {
    const local = ORG_STRUCTURES.find((entry) => entry.id === item?.id);
    return {
      ...(local || {}),
      ...item,
      levels: Array.isArray(item?.levels) ? item.levels : local?.levels || [],
      ranks: Array.isArray(item?.ranks) ? item.ranks : local?.ranks || [],
      usesBranches: Boolean(item?.usesBranches ?? local?.usesBranches),
      usesSections: Boolean(item?.usesSections ?? local?.usesSections),
    };
  });
}

/**
 * Ranks offered for the active structure, still respecting department rules.
 * The employee's current rank stays visible so an existing assignment is not hidden.
 */
export function filterMemberTypesForStructure(
  structure,
  memberTypes,
  { departmentId, currentId } = {},
) {
  const allowed = new Set(structure?.ranks || []);
  let list = memberTypes.filter((type) => allowed.has(type.id));
  if (departmentId) {
    list = getMemberTypesForDepartment(departmentId, list);
  }
  if (currentId && !list.some((type) => type.id === currentId)) {
    const current = memberTypes.find((type) => type.id === currentId);
    if (current) list = [...list, current];
  }
  return list;
}
